module.exports = __webpack_public_path__ + "f970dafc.svg";